function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Swiper, defaultSwiperSettings } from '../../../src/js/swiper-utils';
jQuery(document).ready(function ($) {
  function syncColumnHeights() {
    // Check if the screen width is greater than 365px
    if (window.matchMedia("(min-width: 365px)").matches) {
      // Loop through each table slider block individually
      $('.table-slider-block').each(function () {
        var $table = $(this); // Current table
        // Reset all heights to auto first for recalculation

        $table.find('.fixed-column-item').css('height', 'auto');
        $table.find('.table-swiper-container .column-content .column-item').css('height', 'auto'); // Get the total number of rows in the fixed-column for the current table

        var numRows = $table.find('.fixed-column-item').length; // Loop through each row index for the current table

        for (var i = 0; i < numRows; i++) {
          // Get the height of the current fixed-column-item in this table
          var fixedColumnHeight = $table.find('.fixed-column-item').eq(i).outerHeight(); // Initialize a variable to store the maximum height in this row across all columns for the current table

          var maxHeight = fixedColumnHeight; // Compare with the heights of the corresponding rows in all columns for the current table

          $table.find('.table-swiper-container .column-content').each(function () {
            var columnItemHeight = $(this).find('.column-item').eq(i).outerHeight();

            if (columnItemHeight > maxHeight) {
              maxHeight = columnItemHeight; // Update maxHeight if the column item is taller
            }
          }); // Apply the max height to the corresponding row in the fixed column and all columns for the current table

          $table.find('.fixed-column-item').eq(i).css('height', maxHeight + 'px');
          $table.find('.table-swiper-container .column-content').each(function () {
            $(this).find('.column-item').eq(i).css('height', maxHeight + 'px');
          });
        } // Now that the height calculations are complete, make the table visible


        $table.find('.table-slider-wrapper').removeClass('invisible'); // Remove the invisible class after calculation
      });
    } else {
      // If the screen size is smaller than 365px, reset heights to auto for all tables
      $('.table-slider-block .fixed-column-item').css('height', 'auto');
      $('.table-slider-block .table-swiper-container .column-content .column-item').css('height', 'auto');
    }
  } // Call the function initially when the document is ready


  syncColumnHeights(); // Call the function on window resize to adjust the heights responsively

  $(window).resize(function () {
    syncColumnHeights();
  });
});
document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelectorAll('.table-swiper-container')) {
    var sliders = document.querySelectorAll('.table-swiper-container');
    sliders.forEach(function (slider) {
      // Determine if this slider should show two slides
      var shouldShowTwoSlides = slider.closest('.table-swiper-container').classList.contains('show-two-slides'); // Use a specific class or attribute

      var developmentsSlider = new Swiper(slider, _objectSpread(_objectSpread({}, defaultSwiperSettings(1, 330, false, false)), {}, {
        spaceBetween: 20,
        centeredSlides: false,
        loop: false,
        slidesPerGroup: 1,
        // Slide one at a time
        navigation: {
          nextEl: [slider.closest('.container').querySelector('.swiper-button-next'), // Existing arrows
          slider.closest('.container').querySelector('.swiper-button-next-mobile') // New mobile arrows
          ],
          prevEl: [slider.closest('.container').querySelector('.swiper-button-prev'), // Existing arrows
          slider.closest('.container').querySelector('.swiper-button-prev-mobile') // New mobile arrows
          ]
        },
        breakpoints: {
          640: {
            slidesPerView: 1,
            spaceBetween: 40
          },
          1024: {
            slidesPerView: shouldShowTwoSlides ? 2 : 3,
            // Show 2 slides if needed
            spaceBetween: 0
          }
        }
      }));
    });
  }
});